/* eslint-disable no-magic-numbers */
export enum ProductAction {
  Create = 1,
  Edit = 2,
  Use = 3,
  Delete = 4,
  Adjust = 5,
  Add = 6,
  TransferFromStorage = 9,
  TransferToStorage = 10,
}
